import React from 'react';

interface RevenueCardProps {
  value: string;
  change: string;
  period: string;
  isMobile: boolean;
}

export const RevenueCard: React.FC<RevenueCardProps> = ({
  value,
  change,
  period,
  isMobile,
}) => {
  const styles = {
    revenueCard: {
      background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
      borderRadius: '8px',
      padding: '20px',
      color: '#fff',
      position: 'relative' as const,
      boxShadow: '0 4px 12px rgba(34,197,94,0.3)',
      flex: '0 0 auto',
    },
    periodBadge: {
      position: 'absolute' as const,
      top: '10px',
      right: '10px',
      background: 'rgba(255,255,255,0.2)',
      color: '#fff',
      padding: '2px 8px',
      borderRadius: '4px',
      fontSize: '11px',
      fontWeight: 600,
    },
    revenueLabel: {
      fontSize: '15px',
      fontWeight: 500,
      opacity: 0.95,
      marginBottom: '4px',
    },
    revenueValue: {
      fontSize: isMobile ? '36px' : '42px',
      fontWeight: 700,
      marginBottom: '4px',
      letterSpacing: '-1px',
    },
    revenueChange: {
      fontSize: '13px',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      opacity: 0.95,
    },
  };

  return (
    <div style={styles.revenueCard}>
      <div style={styles.periodBadge}>{period}</div>
      <div style={styles.revenueLabel}>Estimated Revenue</div>
      <div style={styles.revenueValue}>{value}</div>
      <div style={styles.revenueChange}>
        <span>↑</span> {change}
      </div>
    </div>
  );
};
